<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 2C2 0.895431 2.89543 0 4 0H12L18 6V18C18 19.1046 17.1046 20 16 20H4C2.89543 20 2 19.1046 2 18V2ZM16 7L11 2V7H16ZM6 6C5.44772 6 5 6.44772 5 7C5 7.55228 5.44772 8 6 8H8C8.55228 8 9 7.55228 9 7C9 6.44772 8.55228 6 8 6H6ZM5 15C5 14.4477 5.44772 14 6 14H10C10.5523 14 11 14.4477 11 15C11 15.5523 10.5523 16 10 16H6C5.44772 16 5 15.5523 5 15ZM6 10C5.44772 10 5 10.4477 5 11C5 11.5523 5.44772 12 6 12H14C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10H6Z"
  />
</svg>
